import React from "react";
import "./knowledgePanel.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faFileAlt, faCode, faBriefcase } from "@fortawesome/free-solid-svg-icons";
import profileImg from "../wikipedia/images/jasur.jpg";

const KnowledgePanel = () => {
  return (
    <div className="knowledge-panel">
      <img src={profileImg} alt="Jasur Shukurov" className="kp-photo" />
      <h2 className="kp-name">Jasur Shukurov</h2>
      <p className="kp-title">Lead Software Development Engineer</p>

      <table className="kp-facts">
        <tbody>
          <tr>
            <td>Occupation</td>
            <td>Lead SDE at Amazon</td>
          </tr>
          <tr>
            <td>Education</td>
            <td>Adelphi University — B.S. Computer Science</td>
          </tr>
          <tr>
            <td>Location</td>
            <td>Bay Area, California</td>
          </tr>
          <tr>
            <td>Known for</td>
            <td>Building things that look like other things</td>
          </tr>
        </tbody>
      </table>

      <div className="kp-links">
        <a
          className="kp-link"
          href="https://github.com/jasur-2902"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faCode} /> GitHub
        </a>
        <a
          className="kp-link"
          href="https://www.linkedin.com/in/jasurshukurov/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faBriefcase} /> LinkedIn
        </a>
        <a className="kp-link" href="/email">
          <FontAwesomeIcon icon={faEnvelope} /> Email
        </a>
        <a
          className="kp-link"
          href="/Jasur_Shukurov_public_Resume.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faFileAlt} /> Resume
        </a>
      </div>
    </div>
  );
};

export default KnowledgePanel;
